import styled from "styled-components";


export default styled.div`

.floating {
  margin-bottom:5;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.floatingInput {
  padding: 1.4rem 1rem 0.6rem;
  font-size: 1rem;
  transition: border-color 0.2s ease;
  background: none;
  display: block;
  width: 100%;
  border: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: ${props => props.theme.colors.gray_light_01};
}

.floatingInput:focus {
    border: 1 ;
    outline: 0;
}

.floatingInput::placeholder {
  color:white;
  
}

.floatingLabel {
  display: block;
  position: relative;
  max-height: 0;
  pointer-events: none;
}

.floatingLabel::before {
  content: attr(data-content);
  display: inline-block;
  filter: blur(0);
  backface-visibility: hidden;
  transform-origin: left top;
  transition: transform 0.2s ease;
  left: 1rem;
  position: relative;
}

.floatingLabel::after {
  bottom: 1rem;
  content: "";
  height: 0.1rem;
  position: absolute;
  transition: transform 180ms cubic-bezier(0.4, 0, 0.2, 1),
  opacity 180ms cubic-bezier(0.4, 0, 0.2, 1), background-color 0.3s ease;
  opacity: 0;
  left: 0;
  top: 100%;
  margin-top: -0.1rem;
  transform: scale3d(0, 1, 1);
  width: 100%;
}

// Autocomplete + o label antes
.floatingInput:-webkit-autofill + .floatingLabel::before{
  transform: translate3d(0, -3.12rem, 0) scale3d(0.82, 0.82, 1);
}
// com o texto do placeholder e o label antes
.floatingInput:placeholder-shown + .floatingLabel::before {
  transform: translate3d(0, -2.2rem, 0) scale3d(1, 1, 1);
}

// label antes ou o input com focus e o label antes
.floatingLabel::before,
.floatingInput:focus + .floatingLabel::before {
  transform: translate3d(0, -3.12rem, 0) scale3d(0.82, 0.82, 1);
}

.hiddenVisually {
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

@media (max-width: 350px){
  .floatingInput {
    padding: 1rem 1rem 0.5rem;
    font-size: ${props => props.theme.spacing.spacing_04};//11px;
  }
  .floatingInput:placeholder-shown + .floating__label::before {
    transform: translate3d(0, -1.8rem, 0) scale3d(1, 1, 1);
  }
  .floatingLabel::before,
  .floatingInput:focus + .floatingLabel::before {
    transform: translate3d(0, -2.30rem, 0) scale3d(0.82, 0.82, 1);
  }
}
`;